import _ from "lodash";
import { useEffect, useState } from "react";
import { Button, Dropdown, Form, FormProps, Input, Modal, Segment, Table, TextArea } from "semantic-ui-react";
import { dialogControl } from "../../controls/dialog-control";
import { useCurrentUser } from "../../hooks/auth-hook";
import { ModalControlData, useModalControl } from "../../hooks/commonHooks";
import { useFormConnect, useFormData } from "../../hooks/formHooks";
import { hostUrl, httpRequest, restRequest } from "../../http";
import { DataFile, PageData, FixedXValuesData } from "../../models/common_model";
import { fieldError } from "../../utils";
import { Page } from "./Page";

export function FixedXValuesComponent(props: {}) {
    const currentUser = useCurrentUser();
    const [searchData, setSearchField] = useFormData<any>({});
    const [page, setSearchData] = useFormConnect<any, PageData<FixedXValuesData>>({}, 'commons/fixed_x_values/search');

    const editModalControl = useModalControl();
    const [currentEditId, setCurrentEditId] = useState<number>();
    const [reloadNumber, setReloadNumber] = useState(0);

    return <>
        <Segment.Group>
            <Segment attached="top">
                <Form onSubmit={e => {
                    e.stopPropagation();
                    setSearchData(searchData);
                }}>
                    <Form.Group>
                        <Form.Field inline>
                            <Input placeholder="Name" name="name" value={searchData['name'] || ''} onChange={setSearchField} />
                        </Form.Field>
                        <div><Button icon="search" type="submit"></Button></div>
                    </Form.Group>
                </Form>
            </Segment>
            <Segment attached="bottom">
                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <th>Name</th>
                            <th>
                                {currentUser.permissions.commons.fixed_x_values.create && <Button color="blue" icon="add" content="Fixed X Values" size="mini" onClick={e => {
                                    setCurrentEditId(undefined);
                                    editModalControl.setOpen(true);
                                }} />}
                            </th>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {page?.items.map(d => {
                            return <tr key={d.id}>
                                <td>{d.name}</td>
                                <td>
                                    <Button size="mini" onClick={e => {
                                        e.preventDefault();
                                        window.open(hostUrl(`commons/fixed_x_values/${d.id}/download/`), '_blank');
                                    }}>CSV</Button>

                                    {currentUser.permissions.commons.fixed_x_values.delete && <Button onClick={e => {
                                        dialogControl.deletionConfirm(d.name, argee => {
                                            if (argee) {
                                                return restRequest(`commons/fixed_x_values/${d.id}`, null, 'delete').then(() => {
                                                    setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
                                                })
                                            }
                                            return Promise.resolve()
                                        })
                                    }} color="red" icon="delete" size="mini" />}
                                </td>
                            </tr>
                        })}
                    </Table.Body>
                </Table>
                <Page data={page} updatePage={setSearchData}></Page>
            </Segment>
        </Segment.Group>

        <Editor id={currentEditId} modelControl={editModalControl} onFinish={result => {
            setSearchData((searchData: any) => ({ ...searchData, refresh: (searchData.refresh || 1) + 1 }));
            editModalControl.setOpen(false)
            setReloadNumber(n => n + 1);
        }}></Editor>
    </>
}

function Editor(props: { id?: number, modelControl: ModalControlData, onFinish: (data: FixedXValuesData) => void }) {
    const { id, modelControl, onFinish } = props;
    const isCreate = !id;

    const [data, setField, setData] = useFormData<FixedXValuesData>({} as any);
    const [invalidError, setInvalidError] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState<any>();

    useEffect(() => {
        setData({} as any);
        setInvalidError({});
        if (id) {
            setLoading(true);
            restRequest<FixedXValuesData>('commons/fixed_x_values/' + id).then(setData).finally(() => setLoading(false))
        } else {
            setData(d => ({ ...d }))
        }
    }, [id])

    const onSubmit = (event: React.FormEvent<HTMLFormElement>, formProps: FormProps) => {
        event.stopPropagation();
        event.preventDefault();

        setLoading(true);

        const formData = new FormData();
        for (const key of Object.keys(data)) {
            formData.append(key, (data as any)[key]);
        }

        if (file) {
            formData.append('csv_file', file);
        }

        httpRequest<FixedXValuesData>(`commons/fixed_x_values${isCreate ? '' : '/' + id}`, formData, isCreate ? 'post' : 'put', {}).then(result => {
            props.onFinish(result);
            setInvalidError({});
        }, resp => {
            if (resp.status === 2) {
                setInvalidError(resp.data);
            }
        }).finally(() => setLoading(false));
    }

    return <>
        <Modal {...modelControl.props} size="large">
            <Modal.Header>{isCreate ? 'Create' : 'Update'} Fixed X Values </Modal.Header>
            <Modal.Content>
                <Form onSubmit={onSubmit} loading={loading}>
                    <Form.Group widths="equal">
                        <Form.Input label="Name" name="name" value={data['name'] || ''} onChange={setField} required error={fieldError('name', invalidError)}>
                        </Form.Input>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Input label="CSV File" required error={fieldError('csv_file', invalidError)}>
                            <input type="file" name="csv_file" onChange={e => {
                                if (e.target.files && e.target.files.length > 0) {
                                    setFile(e.target.files[0]);
                                }
                            }} />
                        </Form.Input>
                    </Form.Group>
                    <div>
                        <Button primary>Submit</Button>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button as="a" onClick={e => props.modelControl.setOpen(false)}>Cancel</Button>
                    </div>
                </Form>
            </Modal.Content>
        </Modal>
    </>
}